import axios from 'axios'

export default axios.create({
  headers: localStorage.user ? JSON.parse(localStorage.user) : undefined
})
